module.exports = __webpack_public_path__ + "img/Screenshot 2026-05-26 032746.f2e6ddac.png";